import { combineReducers } from "@reduxjs/toolkit";

import { useAppSelector } from "@redux/hooks";

import basicEndorsementDetailsSlice from "../basicEndorsementDetails";

import endorsementSlice from "./endorsementSlice";

export * from "./endorsementSlice";
export {
  buildCoveragesInput,
  buildPolicyCoveragesInput,
} from "./buildEndorsementInput";
export { default as endorsementSlice } from "./endorsementSlice";
export { IssueEndorsementStatus } from "./types";
export type {
  EndorsementFormPayload,
  EndorsementMode,
  PaymentMethodKey,
  ProjectedPolicyLevelCoverages,
  ProjectedUnitLevelCoverages,
} from "./types";
export * from "../basicEndorsementDetails";

/**
 * Combined endorsement reducers, registered in the main store under the
 * `endorsement` key.
 */
export const endorsementReducers = combineReducers({
  basicEndorsementDetails: basicEndorsementDetailsSlice.reducer,
  endorsement: endorsementSlice.reducer,
});

export type EndorsementRootState = ReturnType<typeof endorsementReducers>;

/**
 * Reads endorsement state via the main store. Slice selectors auto-root to
 * their slice within `state.endorsement`.
 */
export const useEndorsementSelector = <T>(
  selector: (state: EndorsementRootState) => T
) => useAppSelector((state) => selector(state.endorsement));
